import { ReactElement, ReactNode, HTMLAttributes } from 'react';

interface Notification extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

function Notification({ children }: Notification): ReactElement {
  return (
    <div className="relative bg-black rounded p-2 text-white text-smallRegular">
      {children}
    </div>
  );
}

export default Notification;
